export const buddiesSfx = {
  cakeEvolve: {
    volume: 1,
    background: false,
    sources: ['buddies/cake_evolve.mp3'],
  },
};
